import { call, put, takeLatest } from 'redux-saga/effects';

import { UserService, AnalyticsService, webServicesUtil, AppStr } from 'cloak-file-sdk-web'
import { EXIT_ACCOUNT_REQUEST, EXIT_ACCOUNT_SUCCESS, EXIT_ACCOUNT_FAILURE,
	CREATE_USR_USAGE_REQUEST } from '../reducers/upgradeReducer'

// The upgradeAccount saga was removed on 2026-07-29 along with PayPal per-seat
// checkout. It called AccountService.create(name, type, userLimit) to create a Cloak
// File account as part of paying; upgrading now hands off to Stripe checkout in the
// KMS console and creates nothing here. It had already been dead code — UpgradePage
// stopped dispatching UPGRADE_ACCOUNT_REQUEST when it started redirecting instead.

function* exitAccount() {
    try {
        yield call( UserService.exitAccount )
        yield put({ type: EXIT_ACCOUNT_SUCCESS, payload: AppStr.DEFAULT_ACCOUNT })
    } catch (error) {
        let message;
        console.log("errorstr:" + JSON.stringify(error))
        console.log("error.status:" + error.status)
        console.log("error.error_code:" + error.error_code)
        switch (error.status) {
            case 400:
                message = 'wsErrorExitAccount';
                break;
            case 500: message = 'svrErrorExitAccount'; break;
            default: message = 'systemError'
        }
        yield put({ type: EXIT_ACCOUNT_FAILURE, payload: message })
    }
}

export function* createUsrUsage({ payload: { type } }) {
	console.log("in upgradeSaga createUsrUsage type " + type)
	let epId = webServicesUtil().getAuth().ep_id
	console.log("in upgradeSaga createUsrUsage epId " + epId)
	yield call( AnalyticsService.createUsrUsage, type, epId )
}

export function* upgradeSaga() {
	yield takeLatest( EXIT_ACCOUNT_REQUEST, exitAccount )
	yield takeLatest( CREATE_USR_USAGE_REQUEST, createUsrUsage )
}
